// import i18n from '@/i18n'
import router from '@/router'
import i18n, { loadLocaleMessages } from '@/i18n'
import { App } from '@/common/constant'
// import elementPlus from '@/plugins/element'
import globalComponent from '@/plugins/global-component'
import globalMixin from '@/plugins/global-mixin'
import vueMq from '@/plugins/vue-mq.js'
// import reCaptcha from '@/plugins/google-recaptcha.js'
import '@/assets/css/theme/index.min.css'
import '@/assets/css/el-miss.css'
import '@/assets/css/space-helper.css'

const loadI18nMessage = (messages: Record<string, any>) => {
  const locales = Object.keys(messages)

  for (let i = 0; i < locales.length; i++) {
    i18n.global.mergeLocaleMessage(locales[i], messages[locales[i]])
  }
}

const setupPlugins = function (app: any, appName: string | null) {
  let store = null
  const messages = loadLocaleMessages(appName)

  loadI18nMessage(messages)
  switch (appName) {
    case App.Account:
      store = require('@/store/account/index.js').default
      break
    case App.Teacher:
      store = require('@/store/teacher/index.js').default
      break
    case App.Student:
      store = require('@/store/student/index.js').default
      break
  }
  const globalProp = require('@/plugins/global-prop').default

  app.use(router)
  app.use(i18n)
  app.use(store)
  // app.use(elementPlus)
  app.use(globalComponent)
  app.use(globalMixin)
  app.use(vueMq)
  app.use(globalProp)
  // app.use(reCaptcha)
}
export { setupPlugins }
